import "./styles.less";

import { CloseOutlined, FullscreenOutlined } from "@ant-design/icons";
import { useContext, useEffect, useState } from "react";

import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";
import { Tooltip } from "antd";
import dayjs from "dayjs";
import { useRouter } from "next/router";
import YouTube from "@u-wave/react-youtube";

const BannerPIP = ({
	LS_KEY,
	START_TIME,
	END_TIME,
	queryParam = "PIP",
	videoID,
    subtitle = ""
}) => {
	const [show, setShow] = useState<boolean>(false);
	const { country_code } = useContext(ConfigStateContext);
	const { pathname, query } = useRouter();

	const hideBanner = e => {
		e.preventDefault();
		localStorage.setItem(LS_KEY, "false");
		setShow(false);
	};
	const showBanner = () => {
		setShow(true);
	};

	useEffect(() => {
		const d = dayjs();
		if (
			(country_code == "UY" || country_code == "PY") &&
			(pathname.includes("searchPage") ||
				pathname.includes("home") ||
				pathname.includes("propSingle") ||
				pathname.includes("projectSingle")) &&
			((d.isSameOrAfter(START_TIME, "m") && d.isSameOrBefore(END_TIME, "m")) ||
				typeof query[queryParam] != "undefined")
		) {
			if (localStorage.getItem(LS_KEY) == null) {
				showBanner();
			}
		}
	}, []);

	if (!show) return null;

	return (
		<div className={"pip-banner " + pathname.replace("/", "")}>
			<YouTube
                video={videoID}
                controls={false}
                modestBranding={true}
                onReady={(e)=>e.target.playVideo()}
                autoplay
            />
			<Tooltip title={"Cerrar"} placement="left" style={{ maxWidth: 66 }}>
				<CloseOutlined onClick={hideBanner} className="close" size={33} />
			</Tooltip>
			<Tooltip title={"Expandir"} placement="right" style={{ maxWidth: 80 }}>
				<FullscreenOutlined
					className="expand"
					size={33}
					onClick={() => {
						const link =`https://www.youtube.com/watch?v=${videoID}`
						window.open(link, "_blank");
					}}
				/>
			</Tooltip>
			<div className="bottom">
				<p style={{ fontWeight: "normal" }} dangerouslySetInnerHTML={{__html: subtitle}}></p>
			</div>
		</div>
	);
};

export { BannerPIP };
